import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '..';
export function DisplayLabel({ children }) {
    return (_jsx(Text, { type: "s", className: "text-neutral-fg font-medium mb-stack-tight", children: children }));
}
